var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"login-verify"}},[_c('div',{staticClass:"lv-body-container"},[_c('div',{staticClass:"lv-body"},[_vm._v(" Verifying Login Credentials ")]),_c('img',{attrs:{"src":require("@shared/assets/img/general/loading.svg"),"alt":"Verifying"}})])])
}]

export { render, staticRenderFns }